import { HCHotelReview } from '../../../components/HotelReview/HCHotelReview';
import { HotelReview } from '../../../components/HotelReview/HotelReview';
import { withLayout } from '../../../Layout/Layout';
import { httpGet } from '../../../utils/httpClient';
import { MiniHotelReview } from '../../../components/HotelReview/MiniHotelReview';
import qs from 'qs';

export const getServerSideProps = async ({ params, query }) => {
  const reviewRes = await httpGet(
    `${process.env.javaApiUrl}/hotel/review/${params.id}`,
    true
  );
  const recommendationsRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation/hotels/reviews/${params.id}`,
    true
  );
  if (reviewRes.status >= 400) {
    return {
      notFound: true,
    };
  }
  let review;
  let body;
  // Experiment to catch 404 error from SSR 
  try {
    body = await reviewRes.text();
    review = JSON.parse(body);
  } catch (e) {
    console.log('Error parsing review JSON:', e);
    console.log('Server response:', body);
    return {
      notFound: true,
    };
  }

  let recommendation;
  let recommendationsBody;

  try {
    recommendationsBody = await recommendationsRes.text();
    recommendation = JSON.parse(recommendationsBody);
  } catch (e) {
    console.log('Error parsing recommendation JSON:', e);
    console.log('Server recommendation response:', recommendationsBody);
    throw e;
  }

  // const review = await reviewRes.json();
  // const recommendation = await recommendationsRes.json();

  if (review.safename && review.safename !== params.id) {
    delete query.id;
    return {
      redirect: {
        destination: `/hotel/review/${review.safename}?${qs.stringify(query)}`,
        permanent: false,
      },
    };
  }

  return {
    props: {
      review,
      recommendation,
      hotelId: params.id,
    },
  };
};

function HotelReviewHO({ review, recommendation, hotelId }) {
  switch (review.type) {
    case 'HOTELREVIEW':
      return (
        <HotelReview
          review={review}
          recommendation={recommendation}
          hotelId={hotelId}
        />
      );
    case 'EXTERNAL':
      return (
        <HCHotelReview
          review={review}
          recommendation={recommendation}
          hotelId={hotelId}
        />
      );
    case 'HOTELSHORTREVIEW':
      return (
        <MiniHotelReview
          review={review}
          recommendation={recommendation}
          hotelId={hotelId}
        />
      );
  }
}

export default withLayout(HotelReviewHO, true);
